(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9508],{

/***/ 14454:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blockquiry_connect/agency/IncomingReport",
      function () {
        return __webpack_require__(74433);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 93060:
/***/ (function(module) {

"use strict";
/* eslint-disable import/no-relative-packages */ /** @type {import('next-sitemap').IConfig} */ 
module.exports = {
    siteUrl: "https://blockquiry.com",
    generateRobotsTxt: true,
    blockQuiry_connect_secret: "GB8#p*ko7Mp]oJ8iTO2ItDcvtw{i5;k5vks/GTy;f;#p}3*.q!A-G][.-|='HghXf;uIU'VU-r1VJRtiJcVW'FXT9wuLX'+T8wkcm?zL).}1d*a",
    // baseUrlApp: 'http://13.49.44.48:3000/',
    baseUrlApp: "http://localhost:3000/"
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,1057,5443,7847,3842,3517,4540,3835,1816,5426,594,8573,9643,8667,3778,7993,4433,9774,2888,179], function() { return __webpack_exec__(14454); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);